export const genders = {
  Male: 'Męska',
  Female: 'Żeńska',
}

export const filterOptions = (options) => {
  return options
}
